import { Box } from '@mui/material';
import { formatterPTY } from '../../../../utils/utils';

const DataGridTotalFooterColocacion = ({ columns, columnWidths, totalRow }) => {
    return (
        <Box sx={{ display: 'flex', width: 'fit-content' }}>
            {columns.map((col, i) => {
                const isMonetaryColumn = col.field.includes('donacion');
                const isFirst = i === 0;

                let value = totalRow[col.field];

                if (col.field === 'codigo') {
                    const codigoIndex = columns.findIndex(
                        (col) => col.field === 'codigo',
                    );
                    const promotorIndex = columns.findIndex(
                        (col) => col.field === 'promotor',
                    );

                    const codigoWidth = columnWidths[codigoIndex] ?? 120;
                    const promotorWidth = columnWidths[promotorIndex] ?? 120;

                    const totalWidth = codigoWidth + promotorWidth;
                    return (
                        <Box
                            key="total-colspan"
                            sx={{
                                width: totalWidth,
                                minWidth: totalWidth,
                                maxWidth: totalWidth,
                                paddingY: 1,
                                borderTop: `1px solid #0B3E83`,
                                borderBottom: `1px solid #0B3E83`,
                                borderRight: `1px solid #0B3E83`,
                                fontWeight: 'bold',
                                backgroundColor: '#f5f5f5',
                                flexShrink: 0,
                            }}
                        >
                            Total
                        </Box>
                    );
                }

                if (col.field === 'promotor') return null;

                // Si es la primera columna, forzamos "Total"
                if (isFirst) {
                    value = 'Total';
                }

                // Si es columna monetaria, formateamos
                if (isMonetaryColumn && typeof value === 'number') {
                    value = formatterPTY.format(value);
                }

                return (
                    <Box
                        key={col.field}
                        sx={{
                            width: columnWidths[i] ?? 120,
                            minWidth: columnWidths[i] ?? 120,
                            maxWidth: columnWidths[i] ?? 120,
                            paddingY: 1,
                            borderTop: `1px solid #0B3E83`,
                            borderBottom: `1px solid #0B3E83`,
                            borderRight: `1px solid #0B3E83`,
                            textAlign: 'center',
                            fontWeight: 'bold',
                            backgroundColor: '#f5f5f5',
                            flexShrink: 0,
                        }}
                    >
                        {value ?? ''}
                    </Box>
                );
            })}
        </Box>
    );
};

export default DataGridTotalFooterColocacion;
